export class SelfCheckInRoutingRouteNames {
    public static readonly Process = 'process';
    public static readonly SelfCheckInProcessOutlet = 'outlet-self-check-in-process';
    public static readonly ProcessRoutes = {
        PatientSelection: 'patient-selection',
        DataOverview: 'data-overview',
        Success: 'self-check-in-success',
        Error: 'self-check-in-error',
    };
}
